export type PriceCalculationMethodView = {
  id: number;
  name: string;
  textResourceKey: string;
};

export enum CalculationMethods {
  PerStay = 1,
  PerNight = 2,
  PerPersonPerNight = 3,
  PerPerson = 4,
  PerAdultPerson = 5,
  Manual = 6,
  PerChildPerNight = 7,
  PerAdultPerNight = 8,
  PerDay = 9
}